// extracted by mini-css-extract-plugin
module.exports = {"container":"_67e55aed"};